module.exports = __webpack_public_path__ + "img/gardener.c32371ae.png";